import React, { useEffect, Fragment, useState } from 'react';
import { PropTypes } from 'prop-types';
import AutocompleteArrayUsers from '../../Form/AutocompleteArrayUsers';
import setManualPayment from '../../../api/graphql/mutations/setManualPayment';

const UnregisteredPaymentsAssignPayment = ({ productList, formInput }) => {
  const [productListOptions, setProductListOptions] = useState([]);
  const [productSlugName, setProductSlugName] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const { providerEmail, provider, paypalAccountId, purchaseId, transactionId, transactionSubject, fullName } = formInput;

  const assignPaymentToUser = async () => {
    const { _id: paymentFetchedFromProviderId } = formInput;
    const { result, error } = await setManualPayment({
      paymentFetchedFromProviderId,
      email: selectedUser,
      productSlugName,
    });

    if (error) {
      alert(error);
      return;
    }

    if (!result) {
      alert('Unknown error!');
      return;
    }

    alert('Done!');
  };

  useEffect(() => {
    const options = productList.map((productOption) => {
      const {
        slugName, title,
      } = productOption;
      const option = (
        <option key={slugName} value={slugName}>
          {title.es}
        </option>
      );
      return option;
    });
    setProductListOptions(options);
  }, [productList]);

  return (
    <Fragment>
      <div className="bg-black text-white p-4 mt-5">
        <div className="px-3 md:mb-0">
          <div className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span>Provider: &nbsp;</span>
            {provider}
          </div>
          <div className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span>Provider email: &nbsp;</span>
            {providerEmail}
          </div>
          <div className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span>Name: &nbsp;</span>
            {fullName}
          </div>
          <div className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span>Account ID: &nbsp;</span>
            {paypalAccountId}
          </div>
          <div className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span>Purchase ID: &nbsp;</span>
            {purchaseId}
          </div>
          <div className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span>Transaction ID: &nbsp;</span>
            {transactionId}
          </div>
          <div className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            <span>Subject: &nbsp;</span>
            {transactionSubject}
          </div>
        </div>

        <div className="px-3 md:mb-0 pt-4">
          <label className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
            Product
          </label>
          <div className="relative">
            <select
              className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              onChange={newValue => setProductSlugName(newValue.currentTarget.value)}
            >
              <option value="" />
              {productListOptions}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>

        <div className="px-3 md:mb-0 pt-4">
          <label className="block tracking-wide text-gray-700 text-xs font-bold" htmlFor="grid-state">
            User
          </label>
          <div className="relative">
            <AutocompleteArrayUsers message="This user does not exist" storeValue={setSelectedUser} value={formInput.email} title="" />
          </div>
        </div>
      </div>

      <div className="px-3 mb-4">
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={assignPaymentToUser}>
          Assign payment
        </button>
      </div>
    </Fragment>
  );
};

UnregisteredPaymentsAssignPayment.propTypes = {
  productList: PropTypes.arrayOf(PropTypes.object),
  formInput: PropTypes.shape(),
};

UnregisteredPaymentsAssignPayment.defaultProps = {
  productList: null,
  formInput: {},
};

export default UnregisteredPaymentsAssignPayment;
